<!--
	功能：该组件用于实现翻页导航栏显示及控制
	可提供如下功能, 支持的形态及功能有:
		1.  总记录数显示(ctrl.total)
		2.  每页记录条数设置与显示(ctrl.pageSize)
		3.  总页数显示(通过计算得到)
		4.  相关提示文本设置(ctrl.cont)
		5.  第一页、前一页、后一页、最后页、当前页前后共5页导航显示
		6.  指定页码跳转
		7.  可设置是否显示提示信息(总记录数、总页数、每页记录数)
		8.  可设置是否显示指定页码跳转

	组件调用参数:
		参数名           必要性    值域          说明
		ctrl:{
			havNote      必须      bool          是否显示提示信息
			havGo        必须      bool          是否显示指定页码输入框及确定按钮
			total        必须      int           总记录数
			pageSize     必须      int           每页记录条数
			pageIdx      必须      int           当前页码
			cont         必须      string        相关文本['共','条记录,','页','条/页','页码','Go']
			qryFunc      必须      function      查询执行函数function()
		}
	输出的值:

	外部调用方法:
		无
-->

<template>
	<div id="idPagePanel" ref="idPagePanel" :style="{'font-size':this.myFontSize+'px'}">
		<div id="idPageLeft" ref="idPageLeft">
			<font>{{ ctrl.cont[0] }}</font>
			<font style="padding-left:6px; padding-right:6px;">{{ ctrl.total }}</font>
			<font>{{ ctrl.cont[1] }}</font>
			<font style="padding-left:6px;">{{ ctrl.cont[0] }}</font>
			<font style="padding-left:6px; padding-right:6px;">{{ myPages }}</font>
			<font>{{ ctrl.cont[2] }}</font>
			<input type="text" v-model="ctrl.pageSize" :style="{'font-size':myFontSize+'px','width':(myFontSize*3+6)+'px'}" style="margin-left:10px; margin-right:3px; text-align:center; border-radius:3px; text-indent:0px;" maxlength=4>
			<font>{{ ctrl.cont[3] }}</font>
		</div>
		<div id="idPageRight" ref="idPageRight">
				<div class="First" @click="toFirst"></div>
				<div class="Prev" @click="toPre"></div>

				<div v-if="havePre" class="NorPage" style="line-height:10px;">...</div>
				<div v-if="ps[0]" style="line-height:19px;" :class="isCurPage(0)" @click="spPageClick(0);">{{ps[0]}}</div>
				<div v-if="ps[1]" style="line-height:19px;" :class="isCurPage(1)" @click="spPageClick(1);">{{ps[1]}}</div>
				<div v-if="ps[2]" style="line-height:19px;" :class="isCurPage(2)" @click="spPageClick(2);">{{ps[2]}}</div>
				<div v-if="ps[3]" style="line-height:19px;" :class="isCurPage(3)" @click="spPageClick(3);">{{ps[3]}}</div>
				<div v-if="ps[4]" style="line-height:19px;" :class="isCurPage(4)" @click="spPageClick(4);">{{ps[4]}}</div>
				<div v-if="haveAft" class="NorPage" style="line-height:10px;">...</div>

				<div class="Next" @click="toNext"></div>
				<div class="Last" @click="toLast"></div>

				<input type="text" id="idSPPage" ref="idSPPage" v-model="spPageIdx" :placeholder="ctrl.cont[4]" :style="{'font-size':myFontSize+'px','width':(myFontSize*3+6)+'px'}" style="margin-left:10px; margin-right:3px; border-radius:3px; text-align:center; text-indent:0px;" maxlength=4>
				<div id="idSPFind" ref="idSPFind" :style="{'font-size':myFontSize+'px'}" @click="onSPPage">{{ ctrl.cont[5] }}</div>
			</tr></table>
		</div>
	</div>
</template>

<script>

export default {
	name: 'CPage',
	props:['ctrl'],
	data () {
		return {
			havePre: false,           //是否显示前置省略号
			haveAft: false,           //是否显示后置省略号
			ps:[ 0, 0, 0, 0, 0 ],     //需显示的页码

			myPages: 0,               //总页数
			myFontSize: 14,
			myPageWidth: this.myFontSize*3+6,
			spPageIdx: "",
		}
	},
	mounted: function(){
		this.ctrl.pageSize = parseInt( this.ctrl.pageSize );  // 用于处理输入框改变后的数据类型问题

		if( !this.ctrl.havNote ) this.$refs["idPageLeft"].style["display"] = "none";
		if( !this.ctrl.havGo )
		{
			this.$refs["idSPPage"].style["display"] = "none";
			this.$refs["idSPFind"].style["display"] = "none";
		}
		if( this.ctrl.fontSize ) this.myFontSize = this.ctrl.fontSize;

		this.ctrl.self = this;
		this.procPages();
	},
	computed:{

	},
	methods:{
		/* 查询指定页号 */
		onSPPage: function(e){
			if( this.spPageIdx=="" || this.spPageIdx.trim()=="" ) return;
			try{
				this.spPageIdx = parseInt( this.spPageIdx );
			}
			catch(e)
			{
				return;
			}
			if( this.spPageIdx < 1 ) this.spPageIdx = 1;
			if( this.myPages < this.spPageIdx ) this.spPageIdx = this.myPages;
			this.ctrl.pageIdx = this.spPageIdx;
			this.ctrl.qryFunc();
		},
		/* 判断指定序号的页码是否是当前页码 */
		isCurPage: function( pageIdx ){
			for( let i=0; i<this.ps.length; i++ )
			{
				if( this.ps[i] == this.ctrl.pageIdx && pageIdx == i ) return "CurPage";
			}
			return "NorPage";
		},
		/* 跳转到第一页 */
		toFirst: function(){
			this.ctrl.pageIdx = 1;
			this.ctrl.qryFunc();
		},
		/* 跳转到前一页 */
		toPre: function(){
			if( 1 < this.ctrl.pageIdx )
				 this.ctrl.pageIdx = this.ctrl.pageIdx-1;
			else this.ctrl.pageIdx = 1;
			this.ctrl.qryFunc();
		},
		/* 跳转到最后一页 */
		toLast: function(){
			this.ctrl.pageIdx = this.myPages;
			this.ctrl.qryFunc();
		},
		/* 跳转到后一页 */
		toNext: function(){
			if( this.ctrl.pageIdx < this.myPages )
				 this.ctrl.pageIdx = this.ctrl.pageIdx+1;
			else this.ctrl.pageIdx = this.myPages;
			this.ctrl.qryFunc();
		},
		/* 指定页 */
		spPageClick: function( pIdx ){
			this.ctrl.pageIdx = this.ps[ pIdx ];
			this.ctrl.qryFunc();
		},
		/* 处理导航栏显示数据 */
		procPages: function(){
			this.myPages = parseInt((this.ctrl.total + this.ctrl.pageSize -1 ) / this.ctrl.pageSize);  /* 计算总页数 */
			this.ps       = [ 0, 0, 0, 0, 0 ];
			this.havePre  = false;
			this.haveAft  = false;
			this.npage    = "";

			if( 0 < this.myPages )
			{
				var minn=this.ctrl.pageIdx;     /* 当前可显示页号的最小值 */
				var maxn=this.ctrl.pageIdx;     /* 当前可显示页号的最大值 */

				/* 计算 */
				while( 1 )
				{
					if( this.ctrl.total == 0 ) break;
					if( (minn==1 && maxn==this.myPages) || ((maxn-minn)==4) ) break;
					if( 1 < minn ) minn--;
					if( (minn==1 && maxn==this.myPages) || ((maxn-minn)==4) ) break;
					if( maxn < this.myPages ) maxn++;
					if( (minn==1 && maxn==this.myPages) || ((maxn-minn)==4) ) break;
				}
			}
			else
			{
				maxn = 1;
				minn = 1;
				this.myPages = 1;
				this.ctrl.pageIdx = 1;
			}

			if( 1 < minn ) this.havePre = true;                        /* 前置省略号 */

			for( var i=maxn; minn<=i; i-- )                            /* 显示当前页前后的5页 */
			{
				this.ps[i-minn] = i;                                   /* 页号 */
				if( i == this.ctrl.pageIdx ) this.cidx = i-minn;    /* 是当前页 */
			}

			if( maxn < this.myPages ) this.haveAft = true;                    /* 后置省略号 */
		}
	}
}

</script>

<style scoped>

#idPagePanel{ width:100%; height:100%; display:flex; align-items:center; border:0px solid red; }
#idPageLeft{ flex:1 0 auto; height:100%; border:0px solid blue; display:flex; align-items:center; }
#idPageRight{ flex:1 0 auto; height:100%; border:0px solid blue; display:flex; align-items:center; justify-content:flex-end; }

#idSPFind{ border:1px solid #4a4a4a; border-radius:3px; padding-left:3px; padding-right:3px; cursor:pointer; }
#idSPFind:hover{ border: 1px solid #1ec6df; color:#1ec6df; }
#idSPFind:active{ transform: translate(1px, 1px); }

.First{ float:right; border:1px solid #a3a4a5; background:url(/static/images/pagebars.png); background-position: 0px 0px; width:22px; height:22px; line-height:22px; margin-right:3px; cursor:pointer; border-radius:3px; }
.First:hover{ background:url(/static/images/pagebars.png); background-position: -23px 0px; outline:none; border: 1px solid #1ec6df; }
.Last{ float:right; border:1px solid #a3a4a5; background:url(/static/images/pagebars.png); background-position: -46px 0px; width:22px; height:22px; line-height:22px; margin-right:3px; cursor:pointer; border-radius:3px; }
.Last:hover{ background:url(/static/images/pagebars.png); background-position: -69px 0px; outline:none; border: 1px solid #1ec6df;}
.Prev{ float:right; border:1px solid #a3a4a5; background:url(/static/images/pagebars.png); background-position: 0px -23px; width:22px; height:22px; line-height:22px; margin-right:3px; cursor:pointer; border-radius:3px; }
.Prev:hover{ background:url(/static/images/pagebars.png); background-position: -23px -23px; outline:none; border: 1px solid #1ec6df;}
.Next{ float:right; border:1px solid #a3a4a5; background:url(/static/images/pagebars.png); background-position: -46px -23px; width:22px; height:22px; line-height:22px; margin-right:3px; cursor:pointer; border-radius:3px; }
.Next:hover{ background:url(/static/images/pagebars.png); background-position: -69px -23px; outline:none; border: 1px solid #1ec6df;}

.NorPage{ float:right; border:0px solid #a3a4a5; width:auto; height:19px; line-height:22px; text-align:center; margin-right:5px; cursor:pointer; border-radius:5px; padding-left:3px; padding-right:3px; cursor:pointer; -moz-user-select: none;-webkit-user-select: none;-ms-user-select: none;-khtml-user-select: none;user-select: none; }
.NorPage:hover{ color:#1ec6df; }
.CurPage{ float:right; border:0px solid #a3a4a5; width:auto; height:19px; line-height:22px; text-align:center; margin-right:5px; color:#f00; padding-left:3px; padding-right:3px; -moz-user-select: none;-webkit-user-select: none;-ms-user-select: none;-khtml-user-select: none;user-select: none; }
.CurPage:hover{cursor:not-allowed;}

</style>



// WEBPACK FOOTER //
// cpage.vue?569e9a2e